import { ensure, ensureArray, stringType, TType } from "types";

import { configIdType, IId } from "@/core/api";

export interface IKeyword extends IId {
  keyword: string;
}

export const configKeywordType: TType<IKeyword> = {
  ...configIdType,
  keyword: stringType(""),
};

export const keywordType = ensure(configKeywordType);
export const arrayKeywordType = ensureArray(keywordType);
